export const calendar = [
  '0 0 32 32',
  `
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.92" stroke="currentColor" d="M26.267 4.267h-20.533c-1.62 0-2.933 1.313-2.933 2.933v20.533c0 1.62 1.313 2.933 2.933 2.933h20.533c1.62 0 2.933-1.313 2.933-2.933v-20.533c0-1.62-1.313-2.933-2.933-2.933z"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.92" stroke="currentColor" d="M21.867 1.333v5.867"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.92" stroke="currentColor" d="M10.133 1.333v5.867"></path>
<path fill="none" stroke-linejoin="round" stroke-linecap="round" stroke-miterlimit="4" stroke-width="1.92" stroke="currentColor" d="M2.8 13.067h26.4"></path>

`,
]
